import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminRolesListHeader from './ListHeader';
import AdminRolesListItem from './ListItem';

const AdminRolesList = ({
  roles,
  handleDelete,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list roles-list" responsive>
      <thead>
        <AdminRolesListHeader
          {...props}
        />
      </thead>
      <tbody>
        {roles.map(role => (
          <AdminRolesListItem
            key={role.id}
            role={role}
            handleDelete={handleDelete}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminRolesList.propTypes = {
  roles: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default AdminRolesList;
